//Google Maps places API Autocomplete TextField
import React from 'react';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
//import GoogleMap from "google-map-react";
import throttle from 'lodash/throttle';
import LocationOnIcon from '@material-ui/icons/LocationOn';
//const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_MAP_API_KEY;
//COMPONENT DOES NOT LOAD GOOGLE MAPS INDEPENDENTLY, IT MUST HAVE EITHER Map or SingleMap included on the page to work


const autocompleteService = { current: null };
const geocoderService = {current: null};

export default function GooglePlaces(props) {
	  const {onChange, value, label} = props;
  	const [myvalue, setMyValue] = React.useState(null);
  	const [inputValue, setInputValue] = React.useState('');
  	const [options, setOptions] = React.useState([]);

  
  

  	const fetch = React.useMemo(() =>
    	throttle((request, callback) => {
        	autocompleteService.current.getPlacePredictions(request, callback);
      	}, 200),
    	[],
  	);
	const fetchGeo = React.useMemo(() => 
		throttle((request, callback) => {
			geocoderService.current.geocode(request, callback);
		}, 200),
		[]
	);
  
	React.useEffect(() => {
		console.log('props value changed ', value);
		//if(value && value !== myvalue) 
    setMyValue(value);
	}, [value]);

  React.useEffect(() => {
    let active = true;

    
    if (!autocompleteService.current && window.google && window.google.maps && window.google.maps.places) {
      autocompleteService.current =
        new window.google.maps.places.AutocompleteService({fields: ['address_components', 'geometry']});
    }
	if(!geocoderService.current && window.google && window.google.maps && window.google.maps.Geocoder){
		geocoderService.current = new window.google.maps.Geocoder();
	}
  
    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === '') {
      setOptions(myvalue ? [myvalue] : []);
      return undefined;
    }

    fetch({ input: inputValue }, (results) => {
      if (active) {
        let newOptions = [];

        if (myvalue) {
          newOptions = [myvalue];
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }

        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [myvalue, inputValue, fetch, fetchGeo]);

  return (
     
    <Autocomplete
      id="google-places"
      sx={{ width: 300 }}
      getOptionLabel={(option) =>
        typeof option === 'string' ? option : option.description
      }
      filterOptions={(x) => x}
      options={options}
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={myvalue}
      onChange={(event, newValue) => {
        setOptions(newValue ? [newValue, ...options] : options);
        setMyValue(newValue);
		console.log('YOU SELECTED ', newValue);
		if(newValue)
		fetchGeo({address: newValue.description}, (data) => {
		  //console.log('GEOCodED', data);
		  if(data.length > 0){
			  let newlat = data[0].geometry.location.lat();
			  let newlng = data[0].geometry.location.lng();
			  console.log('sending new place');
			  if(onChange) onChange({address: newValue.description, geo_location: newlng+', '+newlat})
			  //console.log('new lat lng', newlat, newlng);
		  } else {
			  console.log('nothing came back', data);
		  }
	  	});
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} fullWidth />
      )}
      renderOption={(props, option) => {
		  console.log(props, option);


        return (
          <li {...props}>
            <Grid container alignItems="center">
              <Grid item>
                <Box
                  component={LocationOnIcon}
                  sx={{ color: 'text.secondary', mr: 2 }}
                />
              </Grid>
              <Grid item xs>
				  {props.description}
              </Grid>
            </Grid>
          </li>
        );
      }}
    />
  );
}
